export const V1_SET_CONTEXT_MENU = 'V1_SET_CONTEXT_MENU'

export default context => {
  return {
    type: V1_SET_CONTEXT_MENU,
    context,
  }
}
